module.exports = __webpack_public_path__ + "img/35.a01dbc77.png";